import { z } from "zod";

export const UserId = z.compile(z.string().nonempty());
export type UserId = z.infer<typeof UserId>;

export const JWTPayload = z.compile(
  z.object({
    id: z.string(),
    email: z.string(),
  }),
);
export type JWTPayload = z.infer<typeof JWTPayload>;

export const passwordMinLength = 8;
export const Password = z.compile(z.string().min(passwordMinLength));

export const AuthJWT = z.compile(z.jwt());

export const AuthSession = z.compile(
  z.object({
    authToken: AuthJWT,
    refreshToken: z.string().nonempty(),
  }),
);
export type AuthSession = z.infer<typeof AuthSession>;

export const LoginResponse = z.compile(
  z.object({
    userId: UserId,
    session: AuthSession,
  }),
);
export type LoginResponse = z.infer<typeof LoginResponse>;
